/**
 * Middleware to persist filter changes to localStorage
 * This implementation saves ticket categories per project
 */
const filterPersistMiddleware = (store) => (next) => (action) => {
	// Process the action first
	const result = next(action);

	// After action is processed, check if we need to update localStorage
	if (action.type === "sharedFilters/setTicketCategoryFilter") {
		try {
			// Get the current state to extract project ID
			const state = store.getState();
			const projectId = state.projectDetails?.id;

			if (!projectId) {
				console.warn(
					"Cannot save ticket category filter: No project ID found",
				);
				return result;
			}

			// Get the current filters from localStorage
			let filtersState;
			try {
				const savedFilters = localStorage.getItem("shared_filters");
				filtersState = savedFilters ? JSON.parse(savedFilters) : {};
			} catch (error) {
				filtersState = {};
			}

			// Update the filter for the current project
			filtersState[projectId] = {
				...filtersState[projectId],
				ticketCategoryId: action.payload,
			};

			// Save back to localStorage
			localStorage.setItem(
				"shared_filters",
				JSON.stringify(filtersState),
			);
		} catch (error) {
			console.error("Failed to save filters to localStorage:", error);
		}
	} else if (action.type === "sharedFilters/resetFilters") {
		try {
			// Get project ID to reset only that project's filters
			const state = store.getState();
			const projectId = state.projectDetails?.id;

			if (projectId) {
				// Only remove filters for current project
				const savedFilters = localStorage.getItem("shared_filters");
				if (savedFilters) {
					const filtersState = JSON.parse(savedFilters);
					delete filtersState[projectId];
					localStorage.setItem(
						"shared_filters",
						JSON.stringify(filtersState),
					);
				}
			} else {
				// Reset all filters if no project ID is specified
				localStorage.removeItem("shared_filters");
			}
		} catch (error) {
			console.error("Failed to remove filters from localStorage:", error);
		}
	}

	return result;
};

export default filterPersistMiddleware;
